import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AllErrorResponse } from 'src/app/shared/models/error-response-from-backend';

@Component({
  selector: 'app-http-error-modal',
  templateUrl: './http-error-modal.component.html',
  styleUrls: ['./http-error-modal.component.scss'],
})
export class HttpErrorModalComponent implements OnInit {
  /*
    J'ai rajouté le globalMessage dans ce composant afin de pouvoir traiter plus explicitement et précisément les erreurs. Cela a été rajouté tard => beaucoup d'erreurs n'ont pas pu être traitées de cette manière
    Structure d'une erreur renvoyée par le back
    {
      "code": number,
      "errors"/ "warnings": {field:string; message:string}[],   => this.messages
      "instance": string;
      "message" : string;    => this.globalMessage
      "status" : number
    }
  */

  messages: AllErrorResponse[];
  globalMessage: string;
  mode: string;

  messagesDisplayArray: Partial<AllErrorResponse>[] = [];
  errors: Partial<AllErrorResponse>[] = [];
  accesDeniedErrors: Partial<AllErrorResponse>[] = [];

  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    if (this.config?.data) {
      this.messages = this.config.data.messages;
      this.mode = this.config.data.mode;
      this.globalMessage = this.config.data.globalMessage;
      switch (this.mode) {
        case 'warningMode':
          this.messages.forEach((x) => {
            this.messagesDisplayArray.push(x);
          });
          break;
        case 'errorsMode':
          this.messages.forEach((x) => {
            this.errors.push(x);
          });
          break;
        case 'accesDeniedMode':
          this.messages.forEach((x) => {
            this.accesDeniedErrors.push(x);
          });
          break;

        default:
          break;
      }
    }
  }
}
